import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Container from "../../hoc/Container";
import ShopCart from "../../components/shop/shopCart";
import ShopRegionList from "../../components/shop/shopRegionList";
import { useDispatch } from "react-redux";
import SteamInfo from "../../components/shop/steamInfo";
import { shouldOpenAccountLinkModal } from "../../components/shop/accountLinkBlock";
import { changeShop, receiveRegionList } from "../../store/order/actions";

const SHOP_TYPE = "steam";
const ADDITIONAL_REGION_INFO = {
  EU: (
    <Container>
    <p><a href="https://yandex.ru/search/?text=hdk+%D0%B2+%D1%82%D0%B5%D0%BD%D0%B3%D0%B5" className="link font-medium" target="_blank" rel="noreferrer">
      Примерный курс
    </a></p>
    <p>🚫 Коды НЕ подходят для РОССИИ</p>
    </Container>
  )
};

function SteamShop() {
  const dispatch = useDispatch();
  const location = useLocation();
  const openAccountLinkModal = shouldOpenAccountLinkModal(location.search);

  useEffect(() => {
    dispatch(changeShop(SHOP_TYPE));
    dispatch(receiveRegionList(SHOP_TYPE));
  }, [dispatch]);

  return (
    <Container>
      <section className="content-block mb-2">
        <h1 className="head-1">Карты Steam</h1>
        <div className="shop-stack">
          <ShopRegionList shop={SHOP_TYPE} />
          <ShopCart shop={SHOP_TYPE} additionalRegionInfo={ADDITIONAL_REGION_INFO} />
          <SteamInfo openAccountLinkModal={openAccountLinkModal} />
        </div>
      </section>
    </Container>
  );
}

export default SteamShop;
